/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ({

/***/ 2:
/***/ (function(module, exports) {

var AppDatepicker = function( $element ) {
    var selectedDates = [];
    var rel;
    var $datepicker;

    function padNumber(number) {
        var ret = new String(number);
        if (ret.length == 1)
            ret = "0" + ret;
        return ret;
    }

    var datepicker = {
        init: function( $el ) {
            var self = this;

            var options = {dateFormat: 'yy-mm-dd', numberOfMonths: 2};

            options.onSelect = function( date ) {
                self.toggleDate( date );
            };

            options.beforeShowDay = function (date) {
                var year = date.getFullYear();
                // months and days are inserted into the array in the form, e.g "01/01/2009", but here the format is "1/1/2009"
                var month = padNumber(date.getMonth() + 1);
                var day = padNumber(date.getDate());
                // This depends on the datepicker's date format
                var dateString = year + "-" + month + "-" + day;

                var gotDate = jQuery.inArray(dateString, selectedDates);
                if (gotDate >= 0) {
                    // Enable date so it can be deselected. Set style to be highlighted
                    return [true, "ui-state-highlight"];
                }
                // Dates not in the array are left enabled, but with no extra style
                return [true, ""];
            };

            rel = jQuery($el.data( 'rel' ));

            var dates = rel.val().split(',');
            for ( i in dates ) {
                this.toggleDate( dates[i] );
            }

            $datepicker = $el.datepicker( options );
        },
        toggleDate: function( date ) {
            var index = jQuery.inArray(date, selectedDates);
            if (index > -1) {
                selectedDates.splice(index, 1);
            }
            else {
                selectedDates.push( date );
            }

            this.updateRel();

        },
        updateRel: function() {
            rel.val( this.getDates().join( ',' ) );
        },
        getDates: function() {
            return selectedDates;
        }
    };

    datepicker.init( $element );
    return datepicker;
};

window.AppDatepicker = AppDatepicker;


/***/ })

/******/ });


// WEBPACK FOOTER //
// admin-multidatepicker.js